import { render } from "./FacebookConnectionPanel.vue?vue&type=template&id=52b1bb6a&scoped=true"
import script from "./FacebookConnectionPanel.vue?vue&type=script&lang=js"
export * from "./FacebookConnectionPanel.vue?vue&type=script&lang=js"

import "./FacebookConnectionPanel.vue?vue&type=style&index=0&id=52b1bb6a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b1bb6a"]])

export default __exports__